import styled from "styled-components";

const BenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  left: 16px;
  top: 859px;
  background: rgb(133, 113, 77);
  border-radius: 0px 24px;
`;

const ImageContainer = styled.div`
  background: rgb(242, 169, 0);
  border-radius: 4px 16px;
  width: 56px;
  height: 56px;
`;

const Title = styled.h5`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: rgb(255, 255, 255);
`;

const TitleItem = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgb(255, 255, 255);
`;

const Description = styled.p`
  font-family: KBFGText;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  color: rgb(255, 255, 255);
  text-align: justify;
`;

const LandingCardBox = function (props) {
  return (
    <BenefitContainer>
      <Title className="mb-4">{props.title}</Title>
      <div className="row">
        {props.items.map((item, i) => {
          return (
            <div className="mb-3 col-lg-4 col-12" key={i}>
              <ImageContainer className="d-flex justify-content-center align-items-center mb-2">
                <img
                  // alt={item.title}
                  src={item.icon}
                  width={40}
                  height={40}
                />
              </ImageContainer>
              <TitleItem className="mb-2">{item.title}</TitleItem>
              <Description
                dangerouslySetInnerHTML={{ __html: item.description }}
              ></Description>
            </div>
          );
        })}
      </div>
    </BenefitContainer>
  );
};

export default LandingCardBox;
